import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { FilePreviewWrapper } from "../FilePreview/FilePreviewWrapper.js";
import { Box } from "../Box/index.js";
import { Snackbar } from "../Snackbar/index.js";
import { useIsMobile } from "../hooks/index.js";
const FilePreviewWithSnackbar = (t0)=>{
    const $ = c(28);
    const { open, onClose, fullScreen: t1, loadDocument, snackbarMessage, action, withZoom: t2, closeIcon: t3, mt: t4, mb: t5, alternativeImageComponent: t6 } = t0;
    const fullScreen = void 0 === t1 ? false : t1;
    const withZoom = void 0 === t2 ? false : t2;
    const closeIcon = void 0 === t3 ? null : t3;
    let t7;
    if ($[0] !== t4) {
        t7 = void 0 === t4 ? {} : t4;
        $[0] = t4;
        $[1] = t7;
    } else t7 = $[1];
    const mt = t7;
    let t8;
    if ($[2] !== t5) {
        t8 = void 0 === t5 ? {} : t5;
        $[2] = t5;
        $[3] = t8;
    } else t8 = $[3];
    const mb = t8;
    const alternativeImageComponent = void 0 === t6 ? false : t6;
    const isMobile = useIsMobile();
    if (!open) return null;
    let t9;
    if ($[4] !== isMobile || $[5] !== open || $[6] !== snackbarMessage) {
        t9 = isMobile && snackbarMessage && /*#__PURE__*/ jsx(Snackbar, {
            open: open,
            message: snackbarMessage,
            action: null,
            className: "aqa_file_preview_snackbar_header",
            zPosition: "top"
        });
        $[4] = isMobile;
        $[5] = open;
        $[6] = snackbarMessage;
        $[7] = t9;
    } else t9 = $[7];
    const t10 = withZoom && !fullScreen;
    let t11;
    if ($[8] !== alternativeImageComponent || $[9] !== closeIcon || $[10] !== fullScreen || $[11] !== loadDocument || $[12] !== mb || $[13] !== mt || $[14] !== onClose || $[15] !== open || $[16] !== t10) {
        t11 = /*#__PURE__*/ jsx(FilePreviewWrapper, {
            onLoad: loadDocument,
            withZoom: t10,
            defaultOpened: open,
            showSnackbarOnDesktop: true,
            fullScreen: fullScreen,
            closeIcon: closeIcon,
            onClickClose: onClose,
            mt: mt,
            mb: mb,
            alternativeImageComponent: alternativeImageComponent
        });
        $[8] = alternativeImageComponent;
        $[9] = closeIcon;
        $[10] = fullScreen;
        $[11] = loadDocument;
        $[12] = mb;
        $[13] = mt;
        $[14] = onClose;
        $[15] = open;
        $[16] = t10;
        $[17] = t11;
    } else t11 = $[17];
    const t12 = isMobile ? "" : snackbarMessage;
    const t13 = fullScreen ? "sticky" : "static";
    const t14 = isMobile && !!snackbarMessage;
    let t15;
    if ($[18] !== action || $[19] !== open || $[20] !== t12 || $[21] !== t13 || $[22] !== t14) {
        t15 = /*#__PURE__*/ jsx(Snackbar, {
            open: open,
            message: t12,
            action: action,
            className: "aqa_file_preview_snackbar_actions",
            zPosition: "bottom",
            variant: t13,
            hideMessage: t14
        });
        $[18] = action;
        $[19] = open;
        $[20] = t12;
        $[21] = t13;
        $[22] = t14;
        $[23] = t15;
    } else t15 = $[23];
    let t16;
    if ($[24] !== t11 || $[25] !== t15 || $[26] !== t9) {
        t16 = /*#__PURE__*/ jsxs(Box, {
            children: [
                t9,
                t11,
                t15
            ]
        });
        $[24] = t11;
        $[25] = t15;
        $[26] = t9;
        $[27] = t16;
    } else t16 = $[27];
    return t16;
};
export { FilePreviewWithSnackbar };
